import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { Props } from './SelectedLayout';
import {
  batchPublish,
  batchDoDelete,
  batchMerge,
  selectBatchAction,
  batchMoveToStash,
  batchMoveToDrafts,
  batchUnpublish,
} from '../../../../actions/studio';
import { AppState, BatchAction } from '../../../../types/store';
import {
  getBatchAction,
  getIsRootFolder,
  getIsUnpublishedDataset,
  getStudioParams,
} from '../../../../selectors/studio';
import {
  confirmMoveSelectionToFolder,
  createFolderFromSelection,
} from '../../../../actions/studio/folders';

export type StateProps = Pick<
  Props,
  'isUnpublishedDataset' | 'batchAction' | 'contentType' | 'isRootFolder'
>;
export type DispatchProps = Pick<
  Props,
  | 'onEditClick'
  | 'onSubmit'
  | 'onUnpublish'
  | 'onDelete'
  | 'onMoveToDrafts'
  | 'onMoveToStash'
  | 'batchMerge'
  | 'onSelectBatchAction'
  | 'onMoveToFolder'
  | 'onCreateFolderFromSelection'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  isUnpublishedDataset: getIsUnpublishedDataset(state),
  isRootFolder: getIsRootFolder(state),
  batchAction: getBatchAction(state),
  contentType: getStudioParams(state).contentType,
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  onEditClick: () => dispatch(pushModal(ModalType.STUDIO_BATCH_EDIT, {})),
  onSubmit: () => dispatch(batchPublish()),
  onUnpublish: () => dispatch(batchUnpublish()),
  onDelete: () => dispatch(batchDoDelete()),
  onMoveToStash: () => dispatch(batchMoveToStash()),
  onMoveToDrafts: () => dispatch(batchMoveToDrafts()),
  batchMerge: () => dispatch(batchMerge()),
  onSelectBatchAction: (action: BatchAction) => dispatch(selectBatchAction(action)),
  onMoveToFolder: (targetFolderId: number) =>
    dispatch(confirmMoveSelectionToFolder(targetFolderId)),
  onCreateFolderFromSelection: () => dispatch(createFolderFromSelection()),
});

export default connect(mapStateToProps, mapDispatchToProps);
